import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {EchoCorpusBullet} from "../DB/echoCorpusBullets/@EchoCorpusBullet.js";

const MTClass = EchoCorpusBullet;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddEchoCorpusBullet extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateEchoCorpusBullet extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteEchoCorpusBullet extends Command<{id: string}> {}
